import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Box } from "@mui/material";
import useStyles from "./calendar-timeline-day-header.style";
import { endOfYear, getDayOfYear, startOfYear } from "date-fns";
import { useOcCalendar } from "oc/hooks";
import isWeekendDay from "oc/utils/is-weekend-day";

export const MyLeaveCalendarTimelineDayHeader = ({ date, isOffRange }: { date: Date; isOffRange: boolean }) => {
  const { i18n } = useTranslation();
  let startDate = startOfYear(date);
  let endDate = endOfYear(date);

  const { data: Calendar } = useOcCalendar({ startDate, endDate });
  let day = getDayOfYear(date);
  let dayState = Calendar.charAt(day - 1);

  let color = "#212121";
  if (isOffRange) {
    color = "#ffffff";
  }
  if (dayState === "F") {
    color = "#cc0033";
  }

  const label = moment(date).locale(i18n.language).format("dd").substring(0, 2);
  const classes = useStyles();
  let selectedClass = isWeekendDay(date)
    ? classes.timelineWeekend
    : classes.timeline;
  return (
    <Box className={classes.root}>
      <span className={selectedClass} style={{ color: color }}>
        {label}
      </span>
    </Box>
  );
};

export default MyLeaveCalendarTimelineDayHeader;
